import { SimpleGrid } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import type { ProjectSummary } from '@/api/projects';
import { EmptyState } from '@/components/EmptyState';
import { ProjectCard } from './ProjectCard';

export interface ProjectListProps {
  projects: ProjectSummary[];
  onCreate?: () => void;
}

export function ProjectList({ projects, onCreate }: ProjectListProps) {
  const { t } = useTranslation('projects');
  if (projects.length === 0) {
    return (
      <EmptyState
        title={t('list.empty')}
        description={t('list.emptyHint')}
        action={onCreate ? { label: t('list.newProject'), onClick: onCreate } : undefined}
      />
    );
  }
  return (
    <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="md">
      {projects.map((p) => (
        <ProjectCard key={p.public_id} project={p} />
      ))}
    </SimpleGrid>
  );
}
